<template>
  <b-modal
    id="modalTour"
    centered
    hide-footer
    hide-header
    hide-actions
    no-close-on-backdrop
    size="lg">
    <section class="c-modal-lection c-modal-lection--tour">
      <div class="c-modal-lection__dialog">
        <div class="br--small overflow-hidden">
          <div
            class="c-guide-tour-presentation c-pulse-card c-pulse-card--tour
              p-3 p-lg-4 text-center white br--small overflow-hidden"
          >
            <div class="c-pulse-card__body">
              <div class="row mb-4 justify-content-center">
                <div class="col-12 col-md-10">
                  <h2 class="w-bold fs-25">Nos reinventamos por ti</h2>
                  <p class="w-medium fs-18">
                    Conoce lo que tenemos y aprende como sacarle el máximo provecho
                  </p>
                </div>
              </div>
              <div class="row mb-5 justify-content-center">
                <div class="col col-12 col-md-9">
                  <div class="c-guide-tour-presentation__buttons d-flex justify-content-center">
                    <button
                      @click="closeTour"
                      class="c-button c-button--white-ghost flex-md-grow-1 me-2"
                    >
                      Saltar
                    </button>
                    <button @click="startTour" class="c-button c-button--white flex-md-grow-1">
                      Iniciar tutorial
                    </button>
                  </div>
                </div>
              </div>
              <p class="mb-0">Sólo verás este aviso una vez</p>
            </div>
            <div class="c-pulse-card__background">
              <span class="c-pulse-card__buble-left"></span>
              <span class="c-pulse-card__buble-right"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      tourStatus: false,
    }
  },
  props: ['user', 'enroll'],
  mounted() {
    if (this.user) this.getTourStatus();
  },
  methods: {
    closeTour: function() {
      this.$bvModal.hide('modalTour');

      this.storeUserTour();
    },
    startTour: function() {
      this.closeTour();

      window.setTimeout(()=>{
        this.$tours['tour'].start();
      }, 300)
    },
    storeUserTour: function(){
      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/tours/virtual-room/`;

      fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.tourStatus = data;
      })
      .catch(err => {
        throw err;
      })
    },
    getTourStatus: function(){
      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/tours/virtual-room/`;

      fetch(url, {
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        this.tourStatus = data;

        if (!this.tourStatus && this.enroll)
          window.setTimeout(()=>{
            this.$bvModal.show('modalTour');
          }, 1000)
      })
      .catch(err => {
        throw err;
      })
    },
  },
}
</script>
